import AppContext from "AppContext";
import Icon from "components/common_components/Icon";
import React, { useContext } from "react";
import { useHistory } from "react-router-dom";
import { getTodayRelativeDate } from "utils/dateUtils";

function GeneralNotification({ notification }) {
    const history = useHistory();
    const {
        api: {
            General: { GeneralNotifications },
        },
        markCachedNotificationsAsRead,
    } = useContext(AppContext);

    const { id, title, message, referenceType, reference2Type, metadata, createdAt, authorName } = notification || {};

    const parsedMetadata = (() => {
        try {
            return JSON.parse(metadata || "[]");
        } catch {
            return [];
        }
    })();

    const onMarkAsRead = async () => {
        await GeneralNotifications.markAsRead([id]);
        markCachedNotificationsAsRead("general", [id]);
    };

    const onCloseClickHandler = (event) => {
        event.preventDefault();
        event.stopPropagation();
        onMarkAsRead();
    };

    const onCaseLinkClick = (event, fileCase) => {
        event.preventDefault();
        event.stopPropagation();
        history.push(`/${fileCase.module}?fileCaseId=${fileCase.id}`);
    };

    const onVisitorLinkClick = (event, visitor) => {
        event.preventDefault();
        event.stopPropagation();
        history.push(`/visitors/${visitor.id}`);
    };

    return (
        <div className="general-notification">
            <div className="actions">
                <div className="close" onClick={onCloseClickHandler}>
                    <Icon name="cancel" size="xxs" color="secondary" />
                </div>
            </div>
            <div className="title">{title}</div>
            <p className="message">{message}</p>
            {referenceType === "SIGN_IN_SHEET" && reference2Type === "CASE_FILE_NO" && parsedMetadata.length > 0 && (
                <div className="reference-objects">
                    {parsedMetadata.map((fileCase) => (
                        <span key={fileCase.id} className="object-badge" onClick={(e) => onCaseLinkClick(e, fileCase)}>
                            <span>{fileCase.fileNo}</span>
                            <Icon name="open-new-tab" size="sm" color="secondary" />
                        </span>
                    ))}
                </div>
            )}
            {referenceType === "SIGN_IN_SHEET" && reference2Type === "VISITOR_ID" && parsedMetadata.length > 0 && (
                <div className="reference-objects">
                    {parsedMetadata.map((visitor) => (
                        <span key={visitor.id} className="object-badge" onClick={(e) => onVisitorLinkClick(e, visitor)}>
                            <span>{visitor.fullName}</span>
                            <Icon name="open-new-tab" size="sm" color="secondary" />
                        </span>
                    ))}
                </div>
            )}
            <div className="meta">
                <span className="author">{authorName}</span>
                <span className="date">{getTodayRelativeDate(createdAt)}</span>
            </div>
        </div>
    );
}

export default GeneralNotification;
